import { type PropsWithChildren } from 'react';

import { Typography } from '@packages/fenrir/components/typography';

import styles from './spidr-library-tab-content.module.css';

/* -------------------------------------------------------------------------------------------------
 * SpidrLibraryTabContentDescription
 * -----------------------------------------------------------------------------------------------*/
const SpidrLibraryTabContentDescription = ({ children }: PropsWithChildren) => {
  return (
    <Typography paragraph className={styles['tab-description']}>
      {children}
    </Typography>
  );
};

/* -------------------------------------------------------------------------------------------------
 * SpidrLibraryTabContentTableContainer
 * -----------------------------------------------------------------------------------------------*/
const SpidrLibraryTabContentTableContainer = ({
  children,
}: PropsWithChildren) => {
  return <div className={styles['table-container']}>{children}</div>;
};

/* -------------------------------------------------------------------------------------------------
 * SpidrLibraryTabContent
 * -----------------------------------------------------------------------------------------------*/
const SpidrLibraryTabContent = ({ children }: PropsWithChildren) => {
  return <div className={styles['spidr-library-tab-content']}>{children}</div>;
};

export {
  SpidrLibraryTabContent,
  SpidrLibraryTabContentDescription,
  SpidrLibraryTabContentTableContainer,
};
